`use strict`;

import ShowDatepicker from '../libs/datepicker';

new ShowDatepicker(".js-div-datepicker");